import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@repo/shared-client/components/ui'
import { useTranslation } from '@web/src/lib/intl/react'
import { HomeIcon, PlusIcon, ShareIcon } from 'lucide-react'
import { type ComponentProps } from 'react'

type PwaInstallInstructionsModalProps = Omit<ComponentProps<typeof Dialog>, 'onOpenChange'> & {
  onGotItClicked?: () => void
  onOpenChange?: (details: { open: boolean }) => void
}

const PwaInstallInstructionsModal = (props: PwaInstallInstructionsModalProps) => {
  const { t } = useTranslation()
  const { onGotItClicked, onOpenChange, ...rest } = props

  const closeDialog = () => {
    onGotItClicked?.()
    onOpenChange?.({ open: false })
  }

  return (
    <Dialog disablePointerDismissal onOpenChange={(nextOpen) => onOpenChange?.({ open: nextOpen })} {...rest}>
      <DialogContent initialFocus={false} showCloseButton>
        <DialogHeader>
          <DialogTitle>{t('Install SpicyFriends APP on iOS')}</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-6">
          <p>
            {t('Follow these steps to install SpicyFriends on your iOS device')}{' '}
            <span className="font-bold text-primary">({t('Only works from Safari')})</span>
            {':'}
          </p>

          <ol className="ml-5 list-decimal space-y-4">
            <li className="flex items-start gap-2">
              <ShareIcon aria-hidden className="mt-0.5 size-5 shrink-0" />
              <span>
                {t('Tap the')} <strong>{t('Share')}</strong> {t('button in')}{' '}
                <span className="font-bold text-primary">{t('Safari')}</span>
              </span>
            </li>
            <li className="flex items-start gap-2">
              <PlusIcon aria-hidden className="mt-0.5 size-5 shrink-0" />
              <span>
                {t('Select')} <strong>{t('Add to Home Screen')}</strong>
              </span>
            </li>
            <li className="flex items-start gap-2">
              <HomeIcon aria-hidden className="mt-0.5 size-5 shrink-0" />
              <span>
                {t('Tap')} <strong>{t('Add')}</strong> {t('in the top-right corner')}
              </span>
            </li>
          </ol>

          <p className="rounded-md bg-muted p-4">
            {t(
              'Once installed, you can launch SpicyFriends directly from your home screen and enjoy a full-screen, app-like experience with push notifications.'
            )}
          </p>
        </div>

        <DialogFooter>
          <Button onClick={closeDialog} type="button">
            {t('Got it')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default PwaInstallInstructionsModal
